<template>
  <router-view />
</template>
<script>
  export default {
    name: 'agents'
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/agents/index.vue